import { Component, OnInit, Pipe, PipeTransform, Input, SimpleChanges, Output, EventEmitter, ViewChild, ElementRef, OnChanges } from '@angular/core';
import { DomSanitizer} from '@angular/platform-browser';
import { FormGroup } from '@angular/forms';
import { getMatInputUnsupportedTypeError } from '@angular/material/input';
import { ApiService, ABCisApi } from 'src/app/handlers/apiHandler.service';
import { DocumentEditorComponent } from '../document-editor/document-editor.component';
import { HttpErrorResponse } from '@angular/common/http';
import { LoggerService } from 'src/app/handlers/logger.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'pdf-viewer',
  standalone: false,
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss']
})

/**
 * The PDF Viewer Component handles the viewing of pdf file inside the filesapi
 * This includes adding extra handling to the document editor component and
 * implmenting a is being watched feature!
 */
export class PdfViewerComponent extends DocumentEditorComponent  implements OnInit, OnChanges {
  @Input() declare uuid: any;
  @Output() pdfWidth = new EventEmitter<number>();

  //viewed: boolean = false;
  blob: string = '';
  toggle: boolean = true;

  constructor(private apiHandler: ApiService,
    private sanitizer: DomSanitizer,  // No its not named that way for a reason
    private document:ElementRef,
    private logger: LoggerService,
    private toastr: ToastrService) {
    super (apiHandler);
  }

  /**
   * On component initialization handle loading a file
   */
  ngOnInit() {
  }

  /**
   * On input change also handle loading a file
   */
  ngOnChanges() {
    this.LoadFile();
  }

  /**
   * Handles loading of a new file. This includes when no uuid is given.
   */
  LoadFile() {
    this.logger.info(`New PDF with uuid ${this.uuid}`);
    if (this.uuid !== undefined) {
      this.HandleFile();
      this.HandleIsViewed();
    } else {
      // If the uuid is undefined. load an empty pdf
      const fileURL = URL.createObjectURL(new Blob([undefined], { type: 'application/pdf' }));
      if (this.document.nativeElement.querySelector('object') != null) {
        this.document.nativeElement.querySelector('object').data = fileURL + '#view=FitW';
      }
    }
  }

  /**
   * Handle gettings the files content and putting that through the object tag in our html
   */
  HandleFile() {
    // Send a request to the files api to obtain the given file
    const fileRequest = this.apiHandler.getABCisRequest<any>(ABCisApi.Files, `${this.uuid}?pdfOnly=true`, {responseType  : 'arraybuffer' as 'json' });
    fileRequest.then((val) => {
      // After recieving the document data set the document we are viewing
      const data = val.body;
      this.setDocumentId(this.uuid);

      //set the object tag with the pdf blob
      const fileURL = URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));

      this.document.nativeElement.querySelector('object').data = fileURL + '#scrollbar=0&view=FitW';
      this.blob = fileURL + '';
    }). catch(errorResponse => {
      this.toastr.error(errorResponse.error);
    });
  }

  /**
   * Handle if the file we are viewing is being watched by another user
   */
  HandleIsViewed() {
    // Check the api if this file is being viewed
    /*let viewedRequest = this.apiHandler.getABCisRequest(ABCisApi.Files, "IsSomeoneLookingAt/" + this.uuid);
    viewedRequest.then((val:any) => {
      this.viewed = val;
    }).catch((error: HttpErrorResponse) => {
      this.viewed = false;
    });*/
  }

  togglePdf(val: boolean) {
    this.toggle = val;
    if (this.toggle) {
      this.LoadFile();
      this.pdfWidth.emit(null);
    } else {
      this.pdfWidth.emit(65);
    }
  }

  /**
   * sanitize a url allows for safe url transfers. This simply allows browsers to know that the url we are passing through is safe.
   * @param url url being sanitized
   */
  sanitize(url:string){
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }
}
